import React, { useEffect, useState } from 'react'
import ReportsApi from '../../../../api/ReportsApi'
import BarChart from 'components/BarChart'
import { IReportFilter } from 'views/Reports'
import { AccentArea } from 'components'

/**
 * @name ByPlatformPerCardType
 * @desc Render % of Chargebacks by Platform (Top 5) chart
 * @filterValues IReportsFilter
 */
const ByPlatformPerCardType = ({
    filterValues,
}: {
    filterValues: IReportFilter
}): React.ReactElement => {
    const [loading, setLoading] = useState<boolean>(true)
    const [data, setData] = useState<{ [key: string]: number | string }[]>([])
    const [barDataKeys, setBarDataKeys] = useState<[string, number][]>([])

    useEffect(() => {
        if(!filterValues.merchant_id) return
        
        setLoading(true)
        ReportsApi.getByCardTypePerPlatform(filterValues).then((data) => {
            setLoading(false)
            data.length ? setData([data[0]]) : setData([])
            setBarDataKeys(data[1])
        })
    }, [filterValues]) // eslint-disable-line react-hooks/exhaustive-deps

    // Format percentage values based on their magnitude
    const formatPercentTick = (val: number): string => {
        const updatedVal = val * 100
        if (updatedVal === 0) {
            return '0%'
        }

        // For small values (less than 1%), show 2 decimal places
        if (updatedVal < 1) {
            return `${updatedVal.toFixed(2)}%`
        }

        // For larger values, show 1 decimal place
        return `${updatedVal.toFixed(1)}%`
    }

    return (
        <AccentArea title="% of Chargebacks by Card Type Per Platform (Top 5)">
            <BarChart
                data={data}
                loading={loading}
                valueDataKey="value"
                stackedBarValueKeys={barDataKeys}
                showLegend
                customYAxisTickFormatter={formatPercentTick}
                //Remove if no showLegend
                height={230}
            />
        </AccentArea>
    )
}

export default ByPlatformPerCardType
